import { render, staticRenderFns } from "./SearchGameItem.vue?vue&type=template&id=5adee6b4&scoped=true"
import script from "./SearchGameItem.vue?vue&type=script&lang=js"
export * from "./SearchGameItem.vue?vue&type=script&lang=js"
import style0 from "./SearchGameItem.vue?vue&type=style&index=0&id=5adee6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adee6b4",
  null
  
)

export default component.exports